<div class="filter-tags" *ngIf="tags?.length > 0" [ngClass]="isInTitle ? 'no-padding' : 'horizontal-scrolling'">
  <ng-container *ngFor="let tag of tags; trackBy: trackTag">
    <button *ngIf="theme.tagFilteringStyle === tagFilteringStyle.PILLS"
            class="btn filter-tag pill-tag fw-500 font-secondary selection-border-color margin-right-10"
            [ngClass]="{'selection-bg-color selection-inverse-text-color': isTagSelected[tag.name], 'primary-bg-color primary-text-color': !isTagSelected[tag.name], 'item': !isIngredientTagList}"
            (click)="tagClicked.emit(tag.name)"
            title="{{tag.displayName}}"
            [attr.aria-label]="'component.filtering_tags.tag_aria_label' | translate: { tagName: tag.displayName, state: isTagSelected[tag.name] ? 'selected' : 'deselected' }" [attr.aria-pressed]="isTagSelected[tag.name]">
      {{tag.displayName}}
    </button>

    <button *ngIf="theme.tagFilteringStyle === tagFilteringStyle.CHECKBOXES"
            class="btn filter-tag fw-600 font-secondary no-padding margin-right-20"
            [ngClass]="{'item': !isIngredientTagList}"
            (click)="tagClicked.emit(tag.name)"
            title="{{tag.displayName}}"
            [attr.aria-label]="'component.filtering_tags.tag_aria_label' | translate: { tagName: tag.displayName, state: isTagSelected[tag.name] ? 'selected' : 'deselected' }">
      <fa-icon class="text-muted margin-right-5" [icon]="isTagSelected[tag.name] ? faCheck : faTimes" [fixedWidth]="true"></fa-icon>
      <span>{{tag.displayName}}</span>
    </button>

    <button *ngIf="theme.tagFilteringStyle === tagFilteringStyle.COLORED_CHECKBOXES"
            class="btn filter-tag colored-checkbox-tag fw-500 font-secondary margin-right-10"
            [ngStyle]="{'color': tag.textColor || theme.secondaryTextColor, 'background-color': tag.backgroundColor || theme.secondaryBackgroundColor}"
            (click)="tagClicked.emit(tag.name)"
            title="{{tag.displayName}}"
            [attr.aria-label]="'component.filtering_tags.tag_aria_label' | translate: { tagName: tag.displayName, state: isTagSelected[tag.name] ? 'selected' : 'deselected' }">
      <fa-icon class="margin-right-5" [icon]="isTagSelected[tag.name] ? faCheck : faTimes" [fixedWidth]="true"
               [ngClass]="{'icon-invisible': !isTagSelected[tag.name], 'item': !isIngredientTagList}">
      </fa-icon>
      <span>{{tag.displayName}}</span>
    </button>

    <button *ngIf="theme.tagFilteringStyle === tagFilteringStyle.ABBREVIATIONS"
            class="btn filter-tag abbreviation-tag fw-700 font-secondary margin-right-10"
            [ngClass]="{'item': !isIngredientTagList}"
            [ngStyle]="{
              'color': isTagSelected[tag.name] ? tag.textColor || theme.secondaryTextColor : theme.primaryTextColor,
              'background-color': isTagSelected[tag.name] ? tag.backgroundColor || theme.secondaryBackgroundColor : theme.primaryBackgroundColor
            }"
            (click)="tagClicked.emit(tag.name)"
            title="{{tag.displayName}}"
            [attr.aria-label]="'component.filtering_tags.tag_aria_label' | translate: { tagName: tag.displayName, state: isTagSelected[tag.name] ? 'selected' : 'deselected' }">
      {{tag.abbreviation || ((tag.displayName || tag.name) | abbreviation)}}
    </button>
  </ng-container>

  <button *ngIf="hasSelectedTags && theme.tagFilteringStyle === tagFilteringStyle.PILLS"
          class="btn filter-tag pill-tag fw-500 font-secondary primary-bg-color primary-text-color"
          [ngClass]="{'item': !isIngredientTagList}"
          (click)="clearTags.emit()">
    {{'component.filtering_tags.clear_tag_filter' | translate}}
  </button>
</div>
